import { Partner } from "@/modules/partners/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/partners"

export const fetchPartners = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchPartner = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createPartner = async (data?: Partner) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updatePartner = async (id: string, data?: Partner) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deletePartner = async (data: Partner) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updatePartner(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
